/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/magazines.
 */

export interface CmsMagazineIndexEntry {
  slug: string
  kind: string
  publication: string
  issue: string
  title: string
  interviewee: string
  summary: string
  cover_media_id: number | null
  cover_media_uuid: string | null
  pdf_media_id: number | null
  pdf_media_uuid: string | null
  external_url: string | null
  pdf_path: string | null
  issue_date: number | null
  published_at: number | null
}

export const cmsMagazines: CmsMagazineIndexEntry[] = [
  {
    "slug": "學生網騙陷阱層出不窮-魏遠強到蒙養學校分享防騙策略",
    "kind": "article-link",
    "publication": "HK01",
    "issue": "",
    "title": "學生網騙陷阱層出不窮　魏遠強到蒙養學校分享防騙策略",
    "interviewee": "魏遠強先生",
    "summary": "",
    "cover_media_id": 49,
    "cover_media_uuid": "10091751-1e47-4379-ad16-47b3e2a78054",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://www.hk01.com/%E4%B8%AD%E5%B0%8F%E5%AD%B8%E6%A0%A1%E5%9C%92/60385191/%E5%AD%B8%E7%94%9F%E7%B6%B2%E9%A8%99%E9%99%B7%E9%98%B1%E5%B1%A4%E5%87%BA%E4%B8%8D%E7%AA%AE-%E9%AD%8F%E9%81%A0%E5%BC%B7%E5%88%B0%E8%92%99%E9%A4%8A%E5%AD%B8%E6%A0%A1%E5%88%86%E4%BA%AB%E9%98%B2%E9%A8%99%E7%AD%96%E7%95%A5",
    "pdf_path": null,
    "issue_date": 1793239208000,
    "published_at": 1793259902682
  },
  {
    "slug": "青年耀進發展協會行政總監拆解網騙-倡教師化身網絡安全教練",
    "kind": "article-link",
    "publication": "HK01",
    "issue": "",
    "title": "青年耀進發展協會行政總監拆解網騙　倡教師化身「網絡安全教練」",
    "interviewee": "魏遠強先生",
    "summary": "",
    "cover_media_id": 11,
    "cover_media_uuid": "28bef794-03f9-4f00-b425-0dedc84895db",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://www.hk01.com/%E4%B8%AD%E5%B0%8F%E5%AD%B8%E6%A0%A1%E5%9C%92/60390837/%E9%9D%92%E5%B9%B4%E8%80%80%E9%80%B2%E7%99%BC%E5%B1%95%E5%8D%94%E6%9C%83%E8%A1%8C%E6%94%BF%E7%B8%BD%E7%9B%A3%E6%8B%86%E8%A7%A3%E7%B6%B2%E9%A8%99-%E5%80%A1%E6%95%99%E5%B8%AB%E5%8C%96%E8%BA%AB-%E7%B6%B2%E7%B5%A1%E5%AE%89%E5%85%A8%E6%95%99%E7%B7%B4",
    "pdf_path": null,
    "issue_date": 1790208000000,
    "published_at": 1791418947253
  },
  {
    "slug": "flourish-ai",
    "kind": "external",
    "publication": "",
    "issue": "",
    "title": "教育要 flourish，AI 升學顧問如何補上生涯規劃這塊被遺忘的拼圖",
    "interviewee": "魏遠強先生",
    "summary": "",
    "cover_media_id": 12,
    "cover_media_uuid": "717393a3-6234-4118-bb3c-0f82bba81a36",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://www.hk01.com/%E6%95%99%E8%82%B2%E7%99%BC%E5%B1%95/60369852/%E6%95%99%E8%82%B2%E8%A6%81-flourish-ai-%E5%8D%87%E5%AD%B8%E9%A1%A7%E5%95%8F%E5%A6%82%E4%BD%95%E8%A3%9C%E4%B8%8A%E7%94%9F%E6%B6%AF%E8%A6%8F%E5%8A%83%E9%80%99%E5%A1%8A%E8%A2%AB%E9%81%BA%E5%BF%98%E7%9A%84%E6%8B%BC%E5%9C%96",
    "pdf_path": null,
    "issue_date": 1784678400000,
    "published_at": 1791473527479
  },
  {
    "slug": "mingpao-digital-philanthropy-part1-20260224",
    "kind": "image",
    "publication": "《明報》",
    "issue": "經濟版 B6",
    "title": "數字公益進化之路（二之一）",
    "interviewee": "魏遠強先生",
    "summary": "魏遠強先生於《明報》「ICB 明報商機」專欄剖析數字公益的演進：從紙本到網站、社交媒體動員關係資本，以至透明度由年報轉向實時數據流，梳理科技如何重塑公益運作。",
    "cover_media_id": 10,
    "cover_media_uuid": "c5bce77d-d289-46fe-8d5c-517470968033",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://finance.mingpao.com/fin/daily/20260224/1771868655568/魏遠強-數字公益進化之路（二之一）",
    "pdf_path": null,
    "issue_date": null,
    "published_at": 1771891200000
  },
  {
    "slug": "mingpao-digital-philanthropy-part2-20260310",
    "kind": "image",
    "publication": "《明報》",
    "issue": "經濟版 B6",
    "title": "數字公益進化之路（二之二）",
    "interviewee": "魏遠強先生",
    "summary": "魏遠強先生於《明報》「ICB 明報商機」專欄續談數字公益：從直播公益與平台生態，到 AI 預測式公益、物聯網微公益，以至社區韌性數位樞紐，勾勒公益由效率、體驗走向前瞻的進化路徑。",
    "cover_media_id": 9,
    "cover_media_uuid": "336ec223-6029-44fe-9b06-ff1af257e096",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://news.mingpao.com/pns/經濟/article/20260310/s00004/1773074205782/魏遠強-數字公益進化之路（二之二）",
    "pdf_path": null,
    "issue_date": null,
    "published_at": 1773100800000
  },
  {
    "slug": "hk01-parent-lecture-20260915",
    "kind": "external",
    "publication": "《香港01》",
    "issue": "家長講座",
    "title": "《香港01》家長講座　青年耀進發展協會行政總監分享AI時代教養法",
    "interviewee": "魏遠強先生",
    "summary": "魏遠強先生應邀主講「親子同行 x 健康使用AI」家長講座，深入剖析學童使用 AI 的認知卸載與「討好症」盲點，提出「家長應做副駕駛」的核心心法，並推介「家庭AI合約」與「思考三明治」學習法，協助家長在科技世代陪伴孩子前行。",
    "cover_media_id": 8,
    "cover_media_uuid": "a9c7f8d6-5753-4bfa-8cda-8c124f9e9610",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://www.hk01.com/中小學校圈/60388011/香港01-家長講座-青年耀進發展協會行政總監分享ai時代教養法",
    "pdf_path": null,
    "issue_date": null,
    "published_at": 1789430400000
  },
  {
    "slug": "education-professional-49-202609",
    "kind": "pdf",
    "publication": "《教育專業》",
    "issue": "第 49 期",
    "title": "應用 AI 推動生涯規劃創新發展",
    "interviewee": "魏遠強先生",
    "summary": "青年耀進發展協會行政總監魏遠強先生指出，全球四成技能正面臨重新裝備。生涯規劃服務需要從「回應式問答」走向「提問驅動的前瞻探索」，以人機協同、雙軌輔導、微認證四大方向協助香港青年應對 AI 時代的就業變局。",
    "cover_media_id": 7,
    "cover_media_uuid": "314091a6-e8d5-47ea-80c0-3828b0ee18f1",
    "pdf_media_id": null,
    "pdf_media_uuid": null,
    "external_url": "https://www.goodschool.hk/ebook/reader/20260911",
    "pdf_path": "/media/education-professional-no49-yada-202609.pdf",
    "issue_date": null,
    "published_at": 1789084800000
  }
]
